import * as Constants from '../constants/user';

import { getUserPets } from './pet';

export const getUsers = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USERS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/`,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_USERS_SUCCESS, payload: res.data.users });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USERS_FAILED, payload: error });
        reject(error);
      });
  });

export const getUsersByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USERS_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_USERS_BY_URL_SUCCESS, payload: res.data.users });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USERS_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const getUser = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_REQUEST });
    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_USER_SUCCESS, payload: res.data.users });
        dispatch(getUserPets($http, ENV, userId));
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const updateUser = ($http, ENV, userId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_USER_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/identities/${userId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_USER_SUCCESS, payload: res.data.users });
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const getUserActivities = ($http, ENV, userId, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITIES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/user-activities/`,
      params,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_USER_ACTIVITIES_SUCCESS,
          payload: res.data['user-activities'],
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITIES_FAILED, payload: error });
        reject(error);
      });
  });

export const getUserActivity = ($http, ENV, userId, activityId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITY_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/user-activities/${activityId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_USER_ACTIVITY_SUCCESS,
          payload: res.data['user-activities'],
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITY_FAILED, payload: error });
        reject(error);
      });
  });

export const getUserActivitiesByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITIES_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_USER_ACTIVITIES_BY_URL_SUCCESS,
          payload: res.data['user-activities'],
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITIES_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const getLoyaltyStatistics = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_LOYALTY_STATISTICS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/loyalty-statistics/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_LOYALTY_STATISTICS_SUCCESS,
          payload: res.data['loyalty-statistics'],
        });
        resolve(res.data['loyalty-statistics']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_LOYALTY_STATISTICS_FAILED, payload: error });
        reject(error);
      });
  });

export const changeMemberTier = ($http, ENV, userId, tierId) => (dispatch) =>
  new Promise((resolve, reject) => {
    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/member-tier/`,
      data: {
        'loyalty-statistics': {
          requested_tier_id: tierId,
        },
      },
    })
      .then((res) => {
        // change member tier responds with a loyalty statistics object
        dispatch({
          type: Constants.GET_LOYALTY_STATISTICS_SUCCESS,
          payload: res.data['loyalty-statistics'],
        });
        resolve(res.data['loyalty-statistics']);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const changeUserPermissions = ($http, ENV, identityId, groups) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CHANGE_USER_PERMISSIONS_REQUEST });
    const data = { users: { groups: groups } };

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/users/${identityId}/`,
      data,
    })
      .then((res) => {
        dispatch({
          type: Constants.CHANGE_USER_PERMISSIONS_SUCCESS,
          payload: res.data,
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({
          type: Constants.CHANGE_USER_PERMISSIONS_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const authenticateAsUser = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.AUTHENTICATE_AS_USER_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/auth/superuser/${userId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.AUTHENTICATE_AS_USER_SUCCESS,
          payload: res.data,
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({
          type: Constants.AUTHENTICATE_AS_USER_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const getUserGroups = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_GROUPS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/groups/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_USER_GROUPS_SUCCESS,
          payload: res.data['user-groups'],
        });
        resolve(res.data['user-groups']);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_USER_GROUPS_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const getApplicationSubscriptions = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_APPLICATION_SUBSCRIPTION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + '/2.0/applications/',
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_APPLICATION_SUBSCRIPTION_SUCCESS,
          payload: res.data.applications,
        });
        resolve(res.data.applications);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_APPLICATION_SUBSCRIPTION_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const setActiveUser = (user) => (dispatch) => {
  // clear user attributes before setting a new user
  dispatch({ type: Constants.CLEAR_USER_ATTRIBUTES });
  dispatch({
    type: Constants.SET_ACTIVE_USER,
    payload: user,
  });
};

export const setActiveUserInfo = (user_info) => ({
  type: Constants.SET_ACTIVE_USER_INFO,
  payload: user_info,
});

export const getStates = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_STATES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/states/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_STATES_SUCCESS,
          payload: res.data.states,
        });
        resolve(res.data.states);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_STATES_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const getCountries = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_COUNTRIES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/countries/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_COUNTRIES_SUCCESS,
          payload: res.data.countries,
        });
        resolve(res.data.countries);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_COUNTRIES_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const getCommunication = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_COMMUNICATION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/preferences/communication/${userId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_COMMUNICATION_SUCCESS,
          payload: res.data.communication,
        });
        resolve(res.data.communication);
      })
      .catch((error) => {
        dispatch({
          type: Constants.GET_COMMUNICATION_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const saveCommunication = ($http, ENV, userId, communications) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SAVE_COMMUNICATION_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/preferences/communication/${userId}/`,
      data: {
        communication: communications,
      },
    })
      .then((res) => {
        dispatch({
          type: Constants.SAVE_COMMUNICATION_SUCCESS,
          payload: res.data.communication,
        });
        resolve(res.data.communication);
      })
      .catch((error) => {
        dispatch({
          type: Constants.SAVE_COMMUNICATION_FAILED,
          payload: error,
        });
        reject(error);
      });
  });

export const checkUserHasValidAddress = ($http, ENV, userId, identity) => (dispatch) =>
  new Promise((resolve, reject) => {
    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/identities/${userId}/`,
      data: {
        identity: {
          ...identity,
          usps_validate: true,
        },
      },
    })
      .then((res) => {
        dispatch({ type: Constants.SET_USER_HAS_VALID_ADDRESS, payload: true });
        resolve(res.data.identity);
      })
      .catch((error) => {
        dispatch({ type: Constants.SET_USER_HAS_VALID_ADDRESS, payload: false });
        reject(error);
      });
  });

export const clearUserAttributes = () => ({
  type: Constants.CLEAR_USER_ATTRIBUTES,
});

export const setUserAttributeHasValidAddress = (isValid) => ({
  type: Constants.SET_USER_HAS_VALID_ADDRESS,
  payload: isValid,
});

export const setUserAttributeHasBeenValidated = (isValid) => ({
  type: Constants.SET_USER_HAS_BEEN_VALIDATED,
  payload: isValid,
});

export const anonymizeUserProfile = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.ANONYMIZE_USER_REQUEST });
    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/anonymize/`,
    })
      .then((res) => {
        dispatch({ type: Constants.ANONYMIZE_USER_SUCCESS, payload: res.data.users });
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.ANONYMIZE_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const pushUserToSalesforce = ($http, ENV, userId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_REQUEST });
    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/push-salesforce/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_USER_SUCCESS, payload: res.data.users });
        dispatch(getUserPets($http, ENV, userId));
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_FAILED, payload: error });
        reject(error);
      });
  });
